import React from 'react';

export interface ChargeAgainContextValue {
  showChargeAgain: boolean;
  setShowChargeAgain: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ChargeAgainContext = React.createContext<ChargeAgainContextValue | undefined>(undefined);

export default ChargeAgainContext;

